import { Link } from "react-router-dom";
import { storyList, castList, clipList } from "@/utils/catalog";

const entries = [
  {
    to: "/category/story",
    icon: "ri-book-2-line",
    title: "剧情介绍",
    desc: "按季与集数梳理完整剧情，含分集梗概与深度解读。",
    count: storyList.length,
    unit: "篇剧情",
    tone: "bg-primary-50 text-primary-700",
  },
  {
    to: "/category/cast",
    icon: "ri-user-star-line",
    title: "演员名单",
    desc: "主要演员与角色资料齐全，一览台前幕后的人物关系。",
    count: castList.length,
    unit: "位演员",
    tone: "bg-accent-50 text-accent-800",
  },
  {
    to: "/category/clip",
    icon: "ri-film-line",
    title: "精彩片段",
    desc: "剧情回顾、精彩对白与幕后花絮，随时重温名场面。",
    count: clipList.length,
    unit: "段视频",
    tone: "bg-secondary-100 text-secondary-900",
  },
];

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
      <div className="grid gap-4 md:grid-cols-3 md:gap-5">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group rounded-lg border border-background-200/70 bg-background-50 p-6 transition hover:border-primary-300"
          >
            <div className="flex items-center justify-between">
              <span className={`flex h-12 w-12 items-center justify-center rounded-lg text-2xl ${entry.tone}`}>
                <i className={entry.icon}></i>
              </span>
              <i className="ri-arrow-right-up-line text-xl text-foreground-300 transition group-hover:text-primary-500"></i>
            </div>
            <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-900">{entry.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-500">{entry.desc}</p>
            <p className="mt-4 text-xs text-foreground-400">
              共 {entry.count} {entry.unit}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}